import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './layouts/auth/auth.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { MainComponent } from './layouts/main/main.component';
import { PreloadSelectedModulesList } from './preloading-strategy/preload-selected-modules-list';
import { UserResolver } from './user-resolver/user-resolver';

const routes: Routes = [
  {
    path: '',
	component: MainComponent,
	canActivateChild: [AuthGuardService],
	canActivate: [AuthGuardService],
	resolve: [UserResolver],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
	  },
      {
        path: 'dashboard',
		loadChildren: () => import('./dashboard/dashboard-default/dashboard-default.module').then(m => m.DashboardDefaultModule),
		runGuardsAndResolvers: 'always',
	  },
	  {
        path: 'import',
		loadChildren: () => import('./import/import.module').then(m => m.ImportModule),
		runGuardsAndResolvers: 'always',
      },
	  {
		path: 'import/history',
		loadChildren: () => import('./dashboard/dashboard-default/dashboard-default.module').then(m => m.DashboardDefaultModule),
		runGuardsAndResolvers: 'always',
	  },
	  {
		path: 'data-administration',
		loadChildren: () => import('./data-administration/data-administration.module').then(m => m.DataAdministrationModule),
		runGuardsAndResolvers: 'always',
	  },
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
		{
			path: '',
			redirectTo: 'auth',
			pathMatch: 'full',
		  },	
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
	  }
    ]
  },
  {
	  path: '**',
	  redirectTo: 'dashboard'
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  providers: [PreloadSelectedModulesList, AuthGuardService, UserResolver],
  imports: [RouterModule.forRoot(routes,
    {
    onSameUrlNavigation: 'reload',
    preloadingStrategy: PreloadSelectedModulesList
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
